import { rolePermissions } from "./type.model";

  const urlAllow=(user)=>{
    let permissions=user?.permissions?.[0];
    const pathname=window.location.pathname
    let value=true

    let module=pathname.split('/')?.[1]

    let key=rolePermissions.find(itm=>module==itm.url)?.key

    if(key){
      value=permissions?.[`read${key}`]?true:false
    }
    if(user?.role=='admin') value=true
    return value
  }

const permissionModel = { urlAllow }

export default permissionModel